import React from 'react';
import { useGetBidderDetailsData } from '../../hooks/event-store-hooks';
import ValidatorInfoRow, { ValidatorInfoRowProps } from './validator-info-row';
import { useGetLastBlockInfo } from '../../hooks';
import { isValidPublicKey } from '../../utils/account';
import { isObjEmpty } from '../../utils/object';

export const ValidatorFromBidderInfoRow = React.forwardRef<
  HTMLDivElement,
  ValidatorInfoRowProps
>((props: ValidatorInfoRowProps & { validatorPublicKey: string }, ref) => {
  const { data: lastBlock } = useGetLastBlockInfo();
  const auctionEraId = lastBlock && lastBlock?.era_id + 2;

  const { data: bidderData } = useGetBidderDetailsData(
    !props.validator && props.validatorPublicKey
      ? {
          publicKey: props.validatorPublicKey,
          era_id: auctionEraId,
          includes: 'cspr_name',
        }
      : null
  );

  const bidder = bidderData?.data
    ? {
        ...bidderData.data,
        isVerifiedValidator:
          isValidPublicKey(bidderData.data.key) &&
          !isObjEmpty(bidderData.data.accountInfo?.info),
      }
    : null;

  return (
    <ValidatorInfoRow
      {...props}
      ref={ref}
      validator={props.validator || bidder}
    />
  );
});

export default ValidatorFromBidderInfoRow;
